/** 首次进入体验时的声音选择遮罩；用户做出选择前，3D 场景不会持续播放。 */
import { useSoundConfigState } from '../../../atoms/sound-config';
import SoundOnSVG from '../../../svg/sound-on';
import SoundOffSVG from '../../../svg/sound-off';
import classNames from 'classnames';
import { supportsWebp } from '../../../utils/supports-webp';

const SoundConfiguratorScreen = () => {
    const [soundConfig, setSoundConfig] = useSoundConfigState();

    return (
        <div
            // picked 变为 true 后先添加离场类，Dom 延迟 1 秒再真正卸载组件。
            className={classNames('sound-configurator-screen', {
                'sound-configurator-screen--leaving': soundConfig.picked,
            })}
        >
            <div className="sound-configurator-screen-inner-el">
                <img
                    src={`/img/paints/red.${supportsWebp ? 'webp' : 'jpg'}`}
                    width={1920}
                    height={960}
                    alt=""
                    className="sound-configurator-screen__bg"
                />
                <div className="sound-configurator-screen__text">
                    Рекомендуем включить звук для лучшего опыта
                </div>
                <div className="sound-configurator-screen__actions">
                    <button
                        className="sound-configurator-screen__action"
                        aria-label="Включить звук"
                        // picked 代表已选择，enabled 代表播放背景与交互音效。
                        onClick={() =>
                            setSoundConfig({ picked: true, enabled: true })
                        }
                    >
                        <SoundOnSVG />
                    </button>
                    <button
                        className="sound-configurator-screen__action"
                        aria-label="Выключить звук"
                        onClick={() =>
                            setSoundConfig({ picked: true, enabled: false })
                        }
                    >
                        <SoundOffSVG />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SoundConfiguratorScreen;
